module.exports = __webpack_public_path__ + "media/images/data-icons-f0a49a64.png";